import React, { useState } from "react";
import { CONSTANTS } from "../../../constants/app-constant";
import { getCommaSeparatedNumbers } from "../../../utility/common-methods";
import PopperContentField from "../../Shared/PopperContentField";
const {
  DATA_NOT_FOUND,
  EMPTY_STRING,
  ESTIMATED_ARTICLE_READERSHIP,
  ESTIMATED_PREDICETED_ARTICLE_READERSHIP,
  GENRE,
  RANK,
  WEBSITE_RANK,
  WEBSITE_READERSHIP,
  MEDIA_TYPE,
  COUNTRY,
  LANGUAGE,
  OCTDATE,
  PUBLISHDATE,
  WEBSITE_COUNTRY_RANK,
  WEBSITE_GLOBAL_RANK,
  MONTHLY_VISITOR
} = CONSTANTS;

export default function PopoverContent({
  page_per_visits,
  correctedTOS,
  website_global_rank,
  news_type,
  unique_desktop_visitors,
  showAlexaDetails,
  website_category,
  website_category_rank,
  website_country_rank,
  language,
  isOnline,
  location_id,
  opoint_details,
  alexa_details,
  publish_datetime,
  monthly_visitors,
  monthly_visitor
}) {
  const [showPopper, setShowPopper] = useState(false);
  const [beforeNov, setBeforeNov] = useState(false);
  const {
    unique_mobile_visitors,
    country,
    estimated_article_readership,
    expected_predicted_article_readership,
    genre,
    media_type,
    website_rank,
    website_readership,
  } = opoint_details;
  const publishDate = publish_datetime.substring(0, 10);
  useState(() => {
    setBeforeNov(OCTDATE > publishDate);
  }, []);
  const opoint = () => {
    return (
      <>
        <PopperContentField label={PUBLISHDATE} value={publishDate} />
        {/* <PopperContentField
          label={ESTIMATED_ARTICLE_READERSHIP}
          value={getCommaSeparatedNumbers(estimated_article_readership)}
        />
        <PopperContentField
          label={ESTIMATED_PREDICETED_ARTICLE_READERSHIP}
          value={getCommaSeparatedNumbers(
            expected_predicted_article_readership
          )}
        />
        <PopperContentField
          label={WEBSITE_READERSHIP}
          value={getCommaSeparatedNumbers(website_readership)}
        /> */}
        <PopperContentField
          label={MONTHLY_VISITOR}
          value={getCommaSeparatedNumbers(monthly_visitor)}
        />
        <PopperContentField
          label={WEBSITE_COUNTRY_RANK}
          value={getCommaSeparatedNumbers(website_country_rank)}
        />
        <PopperContentField
          label={WEBSITE_GLOBAL_RANK}
          value={getCommaSeparatedNumbers(website_global_rank)}
        />
        <PopperContentField label={GENRE} value={genre} />
        <PopperContentField label={COUNTRY} value={country} />
        <PopperContentField label={LANGUAGE} value={language} />
        <p>
          <div className="popperWrap">
            <div
              className="popperLable"
              onMouseEnter={() => setShowPopper(true)}
              onMouseLeave={() => setShowPopper(false)}
            >
              (* Powered By Similar Web and Opoint)
              {showPopper && (
                <div className="popper-content">
                  <ul className="popper-content-list">
                    <li>
                      <b>{ESTIMATED_ARTICLE_READERSHIP}: </b> The Monthly Visits
                      metric shows the average sum of all non-unique visits per
                      month, during the selected time frame.
                    </li>
                    <li>
                      <b>Monthly Unique Visitors: </b> Monthly Unique Visitors
                      is the sum of devices visiting the analyzed domain, within
                      the country and time period analyzed.
                    </li>
                    <li>
                      <b>{GENRE}: </b> Each website in SimilarWeb is categorized
                      based on SimilarWeb categorization engine. Our code
                      assigns a category for any given website using website
                      content tags, similarity results and a learning set of
                      millions of websites that have verified category
                      assignments. Our engine can accurately classify an unknown
                      website into one of 25 main categories and 219
                      sub-categories.
                    </li>
                    <li>
                      <b>{/* {GENRE / COUNTRY / MEDIA_TYPE} */ RANK}: </b> Rank
                      is a website traffic scoring method developed by
                      SimilarWeb to determine a website’s rank. It calculates
                      the number of monthly unique visitors together with the
                      number of page views across desktop and mobile traffic.
                      Use this metric to discover a website’s relative size
                      globally, domestically and within its category.
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </p>
      </>
    );
  };
  const { page_view_per_mil, page_view_per_usr, rank, reach_per_mil } =
    alexa_details || {};

  return (
    <>
      {opoint_details && !beforeNov && opoint()}
      {showAlexaDetails && beforeNov && (
        <>
          <p>
            <label>Reach per million*: </label>{" "}
            <span>&nbsp;{reach_per_mil || DATA_NOT_FOUND}</span>
          </p>

          <p>
            <label>Page view per million*: </label>{" "}
            <span>&nbsp;{page_view_per_mil || DATA_NOT_FOUND}</span>
          </p>

          <p>
            <label>Page view per user*: </label>{" "}
            <span>&nbsp;{page_view_per_usr || DATA_NOT_FOUND}</span>
          </p>
          <p>
            <label>Website rank*: </label>{" "}
            <span>&nbsp;{rank || DATA_NOT_FOUND}</span>
          </p>
          <p>
            <div className="popperWrap">
              <div
                className="popperLable"
                onMouseEnter={() => setShowPopper(true)}
                onMouseLeave={() => setShowPopper(false)}
              >
                (* Powered By Alexa)
                {showPopper && (
                  <div className="popper-content">
                    <ul className="popper-content-list">
                      <li>
                        <b>Reach per million:</b>&nbsp;Reach measures the number
                        of users. Reach is typically expressed as the percentage
                        of all Internet users who visit a given site,Alexa
                        expresses reach as number of users per million. Alexa's
                        one-week and three-month average reach are measures of
                        daily reach, averaged over the specified time period
                      </li>
                      <li>
                        <b>Page view per million:</b>&nbsp;Page views per
                        million indicates what fraction of all the page views by
                        toolbar users go to a particular site, Multiple page
                        views of the same page made by the same user on the same
                        day are counted only once
                      </li>
                      <li>
                        <b>Page view per user:</b>&nbsp;The page views per user
                        numbers are the average numbers of unique pages viewed
                        per user per day by the users visiting the site
                      </li>
                      <li>
                        <b>Website rank:</b>&nbsp;The rank is calculated using a
                        combination of the estimated average daily unique
                        visitors to the site and the estimated number of
                        pageviews on the site over the past three months
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </p>
        </>
      )}
      {beforeNov && !showAlexaDetails && (
        <>
          <p>
            <label>Monthly Visitor :</label>{" "}
            <span>
              {getCommaSeparatedNumbers(monthly_visitors) || DATA_NOT_FOUND}
            </span>
          </p>
          <p>
            <label>Pages per visit*: </label>{" "}
            <span>{page_per_visits || DATA_NOT_FOUND}</span>
          </p>
          <p>
            <label>Time on site*: </label>{" "}
            <span>{correctedTOS || DATA_NOT_FOUND}</span>
          </p>
          <p>
            <label>Website Global Rank*: </label>{" "}
            <span>{website_global_rank || DATA_NOT_FOUND}</span>
          </p>
          <p>
            <label>Website Category*: </label>{" "}
            <span>{website_category || DATA_NOT_FOUND}</span>
          </p>
          <p>
            <label>Website Category Rank*: </label>{" "}
            <span>{website_category_rank || DATA_NOT_FOUND}</span>
          </p>

          <p>
            <label>Website Country Rank*: </label>{" "}
            <span>{website_country_rank || DATA_NOT_FOUND}</span>
          </p>
          {isOnline && (
            <p>
              <label>Language: </label>{" "}
              <span>{language || DATA_NOT_FOUND}</span>
            </p>
          )}
          <p>
            <label>Unique Mobile Visitor*: </label>
            <span>
              &nbsp;
              {getCommaSeparatedNumbers(unique_mobile_visitors) ||
                DATA_NOT_FOUND}
            </span>
          </p>
          <p>
            <label>Unique Desktop Visitor*: </label>{" "}
            <span>
              {getCommaSeparatedNumbers(unique_desktop_visitors) ||
                DATA_NOT_FOUND}
            </span>
          </p>
          <p>
            <div className="popperWrap">
              <div
                className="popperLable"
                onMouseEnter={() => setShowPopper(true)}
                onMouseLeave={() => setShowPopper(false)}
              >
                (* Powered By Similar web)
                {showPopper && (
                  <div className="popper-content">
                    <ul className="popper-content-list">
                      <li>
                        <b>Monthly Visitors: </b> The Monthly Visits metric
                        shows the average sum of all non-unique visits per
                        month, during the selected time frame.
                      </li>
                      <li>
                        <b>Monthly Unique Visitors: </b> Monthly Unique Visitors
                        is the sum of devices visiting the analyzed domain,
                        within the country and time period analyzed.
                      </li>
                      <li>
                        <b>Website Category: </b> Each website in SimilarWeb is
                        categorized based on SimilarWeb categorization engine.
                        Our code assigns a category for any given website using
                        website content tags, similarity results and a learning
                        set of millions of websites that have verified category
                        assignments. Our engine can accurately classify an
                        unknown website into one of 25 main categories and 219
                        sub-categories.
                      </li>
                      <li>
                        <b>Website Country/Global/Category Rank: </b> Rank is a
                        website traffic scoring method developed by SimilarWeb
                        to determine a website’s rank. It calculates the number
                        of monthly unique visitors together with the number of
                        page views across desktop and mobile traffic. Use this
                        metric to discover a website’s relative size globally,
                        domestically and within its category.
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </p>
        </>
      )}
    </>
  );
}
